import {match} from 'ts-pattern';

import type {KanbanSortBy, OrderByRequestBody} from '@dms/api/core';

import type {Card} from '../types/Card';

export function getKanbanOrder(sortBy: KanbanSortBy, origin: Card['origin']): OrderByRequestBody[] {
  const cardDateColumnKey = origin === 'business-case' ? 'businessCaseUpdatedAt' : 'updatedAt';

  return [
    match(sortBy)
      .with('CREATED_AT_ASC', () => ({columnKey: cardDateColumnKey, order: 'ASC' as const}))
      .with('CREATED_AT_DESC', () => ({columnKey: cardDateColumnKey, order: 'DESC' as const}))
      .with('LAST_ACTIVITY_ASC', () => ({columnKey: 'lastActivityDate', order: 'ASC' as const}))
      .with('LAST_COMMUNICATION_ASC', () => ({
        columnKey: 'lastCommunicationDate',
        order: 'ASC' as const,
      }))
      .exhaustive(),
  ];
}
